export const environment = {
  production: false,
  domainApi: 'leasing-api.siamese-sandbox.com',
  apiUrl: 'https://leasing-api.siamese-sandbox.com',
  authService: '/auth',
  userService: '/user',
  appVersion: 'V ' + require('../../package.json').version,
};
